import * as e from "react";
import s from "../lib/IconBase.es.js";
import n from "../defs/SealQuestion.es.js";
const o = e.forwardRef((t, a) => /* @__PURE__ */ e.createElement(s, { ref: a, ...t, weights: n }));
o.displayName = "SealQuestionIcon";
const c = o;
export {
  o as CircleWavyQuestionIcon,
  c as SealQuestion,
  o as SealQuestionIcon
};
